/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationPolicyDeleteExpectedVersionExclusiveMin = 0;
export const notificationPolicyDeleteExpectedVersionMax = 9007199254740991;

export const NotificationPolicyDelete = zod.object({
  expectedVersion: zod
    .int()
    .gt(notificationPolicyDeleteExpectedVersionExclusiveMin)
    .max(notificationPolicyDeleteExpectedVersionMax),
});

export type NotificationPolicyDelete = zod.input<typeof NotificationPolicyDelete>;
export type NotificationPolicyDeleteOutput = zod.output<typeof NotificationPolicyDelete>;
